"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
var locationsOptions = function locationsOptions() {
  var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var addAllOption = arguments.length > 1 ? arguments[1] : undefined;
  var locationsFormatted = locations.map(function (location) {
    if (location.type === _constant.opportunityLocationType.REMOTE) {
      return {
        id: location.id,
        name: 'Remote'
      };
    }
    if (location.international) {
      if (location.country.id === 214) {
        return {
          id: location.id,
          name: location.countryName
        };
      }
      return {
        id: location.id,
        name: "".concat(location.country.country, ", ").concat(location.cityName)
      };
    }
    return {
      id: location.id,
      name: "".concat(location.city.city, ", ").concat(location.state.name)
    };
  });
  if (addAllOption) {
    locationsFormatted.unshift({
      id: 'all',
      name: 'All'
    });
  }
  return locationsFormatted;
};
var _default = locationsOptions;
exports.default = _default;